export default __webpack_public_path__ + "static/media/watermark.487cfc82.png";